import { MiniQuestionnaireData } from "../types/miniQuestionnaire";

export interface MiniDepistageCard {
  id: string;
  title: string;
  subtitle: string;
  condition: (data: MiniQuestionnaireData) => boolean;
}

export const miniDepistageCards: MiniDepistageCard[] = [
  {
    id: "mammographie",
    title: "Mammographie tous les 2 ans",
    subtitle: "Dépistage du cancer du sein",
    condition: (data) => {
      const age = parseInt(data.age) || 0;
      return data.sexe === "femme" && age >= 50 && age <= 74;
    }
  },
  {
    id: "test_immunologique_fecal",
    title: "Test Immunologique Fécal tous les 2 ans",
    subtitle: "Dépistage du Cancer Colorectal",
    condition: (data) => {
      const age = parseInt(data.age) || 0;
      return (data.sexe === "homme" || data.sexe === "femme") && age >= 50 && age <= 74;
    }
  },
  {
    id: "frottis_cervical",
    title: "Frottis cervical utérin",
    subtitle: "Tous les 3 ans avant 30 ans, puis tous les 5 ans après 30 ans – dépistage du cancer du col",
    condition: (data) => {
      const age = parseInt(data.age) || 0;
      return data.sexe === "femme" && age >= 25 && age <= 65;
    }
  },
  {
    id: "dosage_psa",
    title: "Dosage du PSA",
    subtitle: "Cancer de Prostate",
    condition: (data) => {
      const age = parseInt(data.age) || 0;
      return data.sexe === "homme" && age > 50;
    }
  },
  {
    id: "pression_arterielle",
    title: "Mesure de la Pression Artérielle",
    subtitle: "Annuellement",
    condition: (data) => {
      const age = parseInt(data.age) || 0;
      return age >= 40;
    }
  },
  {
    id: "glycemie_jeun",
    title: "Glycémie à jeun tous les 3 ans",
    subtitle: "Dépistage du Diabète",
    condition: (data) => {
      const age = parseInt(data.age) || 0;
      return age >= 45;
    }
  },
  {
    id: "echographie_doppler",
    title: "Échographie Doppler Abdominale",
    subtitle: "Une fois dans sa vie – Dépistage de l'anévrisme de l'aorte abdominale (AAA)",
    condition: (data) => {
      const age = parseInt(data.age) || 0;
      return data.sexe === "homme" && age >= 65 && age <= 75 && data.tabac_regulier === "oui";
    }
  },
  {
    id: "test_vih",
    title: "Test du VIH",
    subtitle: "Une fois dans sa vie",
    condition: (data) => {
      const age = parseInt(data.age) || 0;
      return age >= 15 && age <= 70;
    }
  },
  {
    id: "depistage_hepatites",
    title: "Dépistage des hépatites B et C",
    subtitle: "Une fois dans sa vie",
    condition: () => true
  },
  {
    id: "consultation_dentiste",
    title: "Consultation annuelle chez le dentiste",
    subtitle: "Santé bucco-dentaire",
    condition: () => true
  },
  {
    id: "consultation_ophtalmologiste",
    title: "Consultation chez l'ophtalmologiste",
    subtitle: "Tous les deux ans",
    condition: (data) => {
      const age = parseInt(data.age) || 0;
      return age >= 40;
    }
  },
  {
    id: "consultation_gynecologique",
    title: "Consultation gynécologique annuelle",
    subtitle: "Suivi gynécologique",
    condition: (data) => data.sexe === "femme"
  },
  {
    id: "scanner_thoracique",
    title: "Scanner thoracique",
    subtitle: "Dépistage du cancer du poumon",
    condition: (data) => {
      const age = parseInt(data.age) || 0;
      return (data.sexe === "homme" || data.sexe === "femme") && 
             age >= 50 && age <= 74 && 
             data.tabac_regulier === "oui";
    }
  },
  {
    id: "vaccination_dtp",
    title: "Vaccination contre la diphtérie, tétanos et poliomyélite",
    subtitle: "À 24, 45 et 65 ans puis tous les 10 ans",
    condition: (data) => {
      const age = parseInt(data.age) || 0;
      return age >= 25;
    }
  },
  {
    id: "vaccin_coqueluche",
    title: "Vaccin contre la coqueluche",
    subtitle: "Rappel à 25 ans",
    condition: (data) => {
      const age = parseInt(data.age) || 0;
      return age >= 25;
    }
  },
  {
    id: "vaccin_grippe",
    title: "Vaccin annuel contre la grippe",
    subtitle: "Prévention saisonnière",
    condition: (data) => {
      const age = parseInt(data.age) || 0;
      return age >= 65;
    }
  },
  {
    id: "vaccin_papillomavirus",
    title: "Vaccin contre le papillomavirus humain",
    subtitle: "Prévention du HPV",
    condition: (data) => {
      const age = parseInt(data.age) || 0;
      return age >= 11 && age <= 19;
    }
  },
  {
    id: "vaccin_covid19",
    title: "Vaccin contre le Covid-19",
    subtitle: "Mise à jour vaccinale",
    condition: (data) => {
      const age = parseInt(data.age) || 0;
      return age >= 65;
    }
  }
];

export const getEligibleMiniDepistages = (data: MiniQuestionnaireData): MiniDepistageCard[] => {
  return miniDepistageCards.filter(card => card.condition(data));
};
